export default __webpack_public_path__ + "static/media/topps.1fa65e2e.svg";